import './style.scss';
import template from './mycrmHome.html';
import MycrmHomeCtrl from './mycrmHomeCtrl';

export default {
  template,
  controller: MycrmHomeCtrl,
  controllerAs: 'vm',
};
